import React, { useState } from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// ROUTING
import { useNavigate } from "react-router-dom";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateOrganizationRefreshTable } from "../../../redux/organizations/organizationSlice";
// COMPONENTS
import ButtonRefreshTable from "../../components/buttons/ButtonRefreshTable";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";
// IMPORT MODAL
import OrganizationImportModal from "./OrganizationImportModal";
// UPGRADE MODAL
import OrganizationUpgradeModal from "./OrganizationUpgradeModal";

function OrganizationsHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const userLogged = useSelector((state: any) => state.home.userLogged);

  const isMasterAdmin =
    userLogged &&
    userLogged.role &&
    userLogged.role.name === process.env.REACT_APP_ROLE_MASTER_NAME;

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickReloadPage = () => {
    dispatch(updateOrganizationRefreshTable(true));
    setTimeout(() => {
      dispatch(updateOrganizationRefreshTable(false));
    }, 1000);
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__pageHeader">
      {hasPermission(Permission.OrgsView, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <ButtonRefreshTable
            onClick={onClickReloadPage}
            label={t("organizationManagement.refreshTable")}
          />
        </div>
      )}
      {/* The Organizations table lists a user's SUB-organizations (children of
          their org), so a non-master admin has no row for their OWN org and
          cannot open it. This button opens the same wizard-edit flow the table
          rows use, targeted at the admin's own organization. */}
      {!isMasterAdmin &&
        userLogged?.organizationId &&
        hasPermission(Permission.WizardInstallerAccess, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1" style={{ marginLeft: 12 }}>
            <Button
              type="primary"
              onClick={() =>
                navigate(`/organization-management/setup-wizard?orgId=${userLogged.organizationId}`)
              }
            >
              {t("organizationManagement.editMyOrganization")}
            </Button>
          </div>
        )}
      {isMasterAdmin && (
        <div className="generalStyles__mlFix mt-1" style={{ marginLeft: 12 }}>
          <Button type="primary" onClick={() => navigate("/organization-management/setup-wizard")}>
            Setup New Organization
          </Button>
        </div>
      )}
      {isMasterAdmin && (
        <div className="generalStyles__mlFix mt-1" style={{ marginLeft: 12 }}>
          <Button onClick={() => setImportModalOpen(true)}>Import Organization</Button>
        </div>
      )}
      {isMasterAdmin && (
        <div className="generalStyles__mlFix mt-1" style={{ marginLeft: 12 }}>
          <Button onClick={() => setUpgradeModalOpen(true)}>Upgrade Organization</Button>
        </div>
      )}
      <OrganizationImportModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={() => {
          dispatch(updateOrganizationRefreshTable(true));
          setTimeout(() => {
            dispatch(updateOrganizationRefreshTable(false));
          }, 1000);
        }}
      />
      <OrganizationUpgradeModal
        open={upgradeModalOpen}
        onClose={() => setUpgradeModalOpen(false)}
        onSuccess={() => {
          dispatch(updateOrganizationRefreshTable(true));
          setTimeout(() => {
            dispatch(updateOrganizationRefreshTable(false));
          }, 1000);
        }}
      />
    </div>
  );
}

export default OrganizationsHeader;
